import { Prompt } from 'react-router-dom';
import * as React from 'react';
import { useFormikContext } from 'formik';

/**
 * Can only be used inside a formik form.
 * Will open an alert for confirmation when the route is changed AND if the form is dirty
 */

type Props = {
  ignoreDirty?: boolean;
};

export const RouterPrompt: React.FunctionComponent<Props> = ({
  ignoreDirty,
}) => {
  const { dirty, isSubmitting } = useFormikContext();
  return (
    <Prompt
      when={(dirty || !!ignoreDirty) && !isSubmitting}
      message="All newly entered data will be lost. Are you sure you want to leave?"
    />
  );
};
